import { NetworkActionPrefix } from '../utils/constants';
import { PersonalTopicApi } from 'for-straction-service-api';
import { networkAPIAction, entityLifecycleActionSet } from '../utils/actionCreatorsFactory';

const personalTopics = {
    loadPersonalTopicList: networkAPIAction.bind(this, new PersonalTopicApi(), 'personalTopicLoadAllGet', NetworkActionPrefix.LOAD_PERSONAL_TOPIC_LIST_PREFIX, {})/*()*/,
    /*addPersonalTopic(personalTopic, sync)/ADD_PERSONAL_TOPIC*/
    /*editPersonalTopic(personalTopic, sync)/EDIT_PERSONAL_TOPIC*/
    /*syncPersonalTopic(personalTopic)/ADD_PERSONAL_TOPIC_PREFIX/EDIT_PERSONAL_TOPIC_PREFIX*/
    ...entityLifecycleActionSet('PersonalTopic', 'PERSONAL_TOPIC', 'personalTopic', new PersonalTopicApi(), {
        'add': 'personalTopicAddPut',
        'edit': 'personalTopicEditPut'
    })
};

export default personalTopics;